import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import { Check } from 'lucide-react';
import type * as React from 'react';
import { Button } from '@verclam/ui-kit';

const wrapperStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
`;

const buttonStyle = css`
	width: 100%;
	justify-content: space-between;
`;

const reasonStyle = css`
	margin: 0;
	padding: 0 0.25rem;
	font-family: ${theme.fonts.body};
	font-size: 0.78125rem;
	color: ${theme.colors.inkFaint};
`;

type Props = {
	readonly label: string;
	readonly selected: boolean;
	/** Non-`null` disables the choice — the reason the server would reject it with a `422`. */
	readonly disabledReason?: string | null;
	readonly onClick: () => void;
};

/**
 * One row of the "Qui parle ?" choice list, shared by the beneficiary choice and every contact
 * choice: a full-width toggle button, a check mark when it is the speaker's current assignment, and
 * a visible reason underneath when disabled — never a silent `422` on click (`guides/pages.md`).
 */
const SpeakerAssignmentChoiceButton: React.FC<Props> = ({
	label,
	selected,
	disabledReason = null,
	onClick,
}) => {
	const disabled = !selected && disabledReason !== null;

	return (
		<div css={wrapperStyle}>
			<Button
				type="button"
				label={label}
				severity={selected ? undefined : 'secondary'}
				outlined={!selected}
				disabled={disabled}
				icon={selected ? <Check size={16} /> : undefined}
				iconPos="right"
				onClick={onClick}
				css={buttonStyle}
			/>
			{disabled && <p css={reasonStyle}>{disabledReason}</p>}
		</div>
	);
};

export default SpeakerAssignmentChoiceButton;
